import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// vuex的模块化操作
import home_store from './home_store.js'
import village_store from './village_store'

export default new Vuex.Store({
  modules: {
    home: home_store,
    village: village_store
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js